import CoverSlider from './CoverSlider';

export default CoverSlider;



// WEBPACK FOOTER //
// ./scripts/elements/CoverSlider/index.js